import Button from '~/src/components/mui-wrappers/buttons/Button'
import { useTranslations } from '~/src/hooks/useTranslations'
import { FormikProps } from 'formik'
import { LoginFormInterface } from '~/src/types/forms/LoginFormInterface'
import LoginForgotPasswordLink from '~/src/components/auth/login/LoginForgotPasswordLink'
import useDialog from '~/src/hooks/useDialog'
import { AuthenticationFlowDialogNameEnum, DialogNameEnum } from '~/src/types/DialogNameEnum'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'
import { useEoState } from '~/src/hooks/useEoState'
import { AUTHENTICATION_FLOW_STATE, AuthenticationFlowState } from '~/src/stores/authentication-flow'
import { DateUtils } from '@eo-storefronts/eo-core'

interface Props {
  loading: boolean,
  form: FormikProps<LoginFormInterface>,
}

const LoginFormActions = ({ loading, form }: Props) => {
  const { t } = useTranslations()
  const { dismiss } = useDialog()
  const { goToStep } = useAuthenticationFlowDialogs()
  const [ authenticationFlowState, setAuthenticationFlowState ] = useEoState<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)

  const _handleOnAskForgotPassword = () => {
    if (authenticationFlowState.customer?.email) {
      dismiss(DialogNameEnum.AUTH_FORGOT_PASSWORD)

      return
    }

    setAuthenticationFlowState((state: AuthenticationFlowState) => ({
      ...state,
      type: 'PASSWORD_RESET',
      confirmationCodeSentAt: DateUtils.addMinutes(3, new Date()).toISOString()
    }))
    dismiss(DialogNameEnum.AUTH_FORGOT_PASSWORD)
    goToStep(AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_CONFIRMATION_CODE)
  }

  return (
    <>
      <Button
        loading={loading}
        disabled={!form.isValid}
        variant='contained'
        type='submit'
        sx={{
          gridArea: 'button',
          fontWeight: 'bold',
          fontSize: '1em',
          minHeight: '42px'
        }}
      >
        {t('auth.logIn')}
      </Button>

      <LoginForgotPasswordLink ForgotPasswordDialogProps={{ onClose: _handleOnAskForgotPassword }}>
        {t('auth.damnIForgotMyPassword')}
      </LoginForgotPasswordLink>
    </>
  )
}

export default LoginFormActions
